import { render, staticRenderFns } from "./VTMysteryLoader.vue?vue&type=template&id=24aa3012&"
import script from "./VTMysteryLoader.vue?vue&type=script&lang=js&"
export * from "./VTMysteryLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports